import { motion } from "framer-motion";
import { AlertCircle, Lightbulb } from "lucide-react";
import { PAIN_POINTS } from "@/lib/salesData";

/* ProblemSection — Agitação de dor com copy emocional e contraste visual forte */
export const ProblemSection = () => {
  return (
    <section className="py-16 sm:py-24 bg-background relative overflow-hidden">
      {/* Glow vermelho sutil de fundo */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[600px] h-[300px] sm:h-[400px] bg-destructive/5 rounded-full blur-3xl pointer-events-none" />

      <div className="container max-w-3xl mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-10 sm:mb-12"
        >
          <span className="text-destructive text-xs font-semibold uppercase tracking-widest mb-3 block">
            A realidade do plantão oncológico
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            Você já viveu isso?
          </h2>
          <p className="text-muted-foreground text-sm sm:text-base">
            Se você reconhece alguma dessas situações, sabe o quanto a falta de
            informação rápida pode custar — para você e para o paciente.
          </p>
        </motion.div>

        <div className="space-y-3">
          {PAIN_POINTS.map((point, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.08 }}
              className="bg-card border border-border rounded-2xl p-4 sm:p-5 flex items-start gap-3 sm:gap-4 hover:border-destructive/40 transition-colors group"
            >
              <div className="shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-destructive/10 border border-destructive/20 flex items-center justify-center mt-0.5 group-hover:bg-destructive/20 transition-colors">
                <AlertCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-destructive" />
              </div>
              <p className="text-foreground text-sm sm:text-base leading-relaxed">{point}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: PAIN_POINTS.length * 0.08 + 0.2 }}
          className="mt-8 bg-accent/10 border-2 border-accent/30 rounded-2xl p-5 sm:p-6 text-center"
        >
          <Lightbulb className="w-7 h-7 sm:w-8 sm:h-8 text-accent mx-auto mb-3" />
          <p className="text-base sm:text-lg font-bold text-foreground mb-1">
            Você precisa de uma ferramenta — não de mais um PDF.
          </p>
          <p className="text-muted-foreground text-xs sm:text-sm">
            Uma plataforma que cabe no bolso, com acesso online, e entrega a resposta em segundos.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
